module.exports = __webpack_public_path__ + "static/img/6.39e38cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/eng/6.png
// module id = H1uK
// module chunks = 0